import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import { getLatestEvents } from "@/utils/events";

export default function LatestNews() {
  const latest = getLatestEvents(6);

  return (
    <section className="mx-auto mt-20 max-w-[1280px] px-4 md:px-6">
      <SectionHeading
        eyebrow="最新赛事资讯"
        title="今日及近期热门赛事动态"
        description="汇总当天与近期的重点赛事，涵盖赛程预告、对阵信息与赛事背景解读。"
        action={
          <Link
            to="/category"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        }
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {latest.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
      </div>
    </section>
  );
}